module.exports = __webpack_public_path__ + "img/006陈建华.2b656944.png";